import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, ArrowRight } from "lucide-react";
import { EASE, slug } from "@/lib/site";

const base = "relative flex items-center gap-1 px-3.5 py-2 text-[15px] font-semibold transition-colors";
const Underline = () => <motion.span layoutId="nav-underline" className="absolute left-3.5 right-3.5 -bottom-0.5 h-[3px] bg-[var(--red)] -skew-x-[30deg]" />;

export default function NavItem({ n }) {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  if (!n.children) {
    return (
      <NavLink to={n.to} end data-testid={`nav-link-${slug(n.to)}`}
        className={({ isActive }) => `${base} ${isActive ? "text-[var(--navy)]" : "text-slate-700 hover:text-[var(--red)]"}`}>
        {({ isActive }) => (<>{n.label}{isActive && <Underline />}</>)}
      </NavLink>
    );
  }

  const active = pathname.startsWith(n.to);
  return (
    <div className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button type="button" data-testid={`nav-dropdown-${slug(n.to)}`} aria-expanded={open} onClick={() => setOpen((o) => !o)}
        className={`${base} ${active || open ? "text-[var(--navy)]" : "text-slate-700 hover:text-[var(--red)]"}`}>
        {n.label}
        <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        {active && <Underline />}
      </button>
      <AnimatePresence>
        {open && (
          <motion.div data-testid={`nav-dropdown-menu-${slug(n.to)}`} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 6 }}
            transition={{ duration: 0.25, ease: EASE }} className="absolute left-0 top-full pt-3 w-72">
            <div className="bg-white border-t-[3px] border-[var(--red)] shadow-[0_30px_60px_-20px_rgba(11,15,38,0.35)] py-2">
              {n.children.map((c) => (
                <NavLink key={c.to} to={c.to} onClick={() => setOpen(false)} data-testid={`nav-sublink-${slug(c.to)}`}
                  className={({ isActive }) => `group flex items-center justify-between px-5 py-3 text-[15px] font-semibold transition-colors ${isActive ? "text-[var(--red)] bg-slate-50" : "text-slate-800 hover:bg-slate-50 hover:text-[var(--navy)]"}`}>
                  {c.label}
                  <ArrowRight className="w-4 h-4 opacity-0 -translate-x-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                </NavLink>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
